const SUCCESS_STATUS_CODE = 200;

export default {
    SUCCESS_STATUS_CODE,
};
